import { useEffect } from 'react';
import { useGetLeverandorProcessListQuery } from '../../../services/rtkApi';
import type {
    LEVERANDOR_REGIONS,
    LeverandorGodkjenningProsessResponse,
} from '../../../types';

export interface ExistingProcessCheckProps {
    orgnummer: string;
    region: LEVERANDOR_REGIONS;
    superOfficeId: string | undefined;
    setExistingProcess: (
        process: LeverandorGodkjenningProsessResponse | null,
    ) => void;
}

export const ExistingProcessCheck = ({
    orgnummer,
    region,
    superOfficeId,
    setExistingProcess,
}: ExistingProcessCheckProps) => {
    const { data, isSuccess, isError } = useGetLeverandorProcessListQuery(
        {
            orgnummer,
            region,
            statuses: ['UnderVurdering'],
        },
        {
            skip: !orgnummer || !region,
        },
    );

    useEffect(() => {
        if (!isSuccess || isError) {
            return;
        }

        if (!data || data.length === 0) {
            setExistingProcess(null);
            return;
        }

        let existingProcess: LeverandorGodkjenningProsessResponse | null =
            data[0];
        if (superOfficeId) {
            existingProcess =
                data.find((p) => p.superOfficeContactId === superOfficeId) ??
                null;
        }

        setExistingProcess(existingProcess);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isSuccess, isError, superOfficeId]);

    // This component doesn't render anything - it just fetches data and reports back
    return null;
};
